import {newBackendAPI} from "../../apiConsumer";

export type UserSettings = {
  acceptPrivacy?: boolean;
  darkMode?: boolean;
  expandedMenu?: boolean;
  showNotifications?: boolean;
};

export interface VersionByUserTypes {
  idPerson: string | number;
  idVersionUpdate: number[];
}

export interface UserPermission {
  idPerson: string | number;
  menus: {
    id: number;
    permissions: {
      view: boolean;
      edit: boolean;
      include: boolean;
      exclude: boolean;
    };
  }[];
}

export const SaveSettings = async (newSetting: UserSettings) => {
  return await newBackendAPI.post("/save-settings", newSetting);
};

export const VersionByUser = async (versionByUserData: VersionByUserTypes) => {
  return await newBackendAPI.post("/version-by-user", versionByUserData);
};

export const AllUsersWithPermission = async () => {
  return await newBackendAPI.get("/menu-users-permissions");
};

export const UserWithPermission = async (id: string | undefined) => {
  return await newBackendAPI.get(`/menu-users-permissions/${id}`);
};

export const NewUserPermission = async (data: UserPermission) => {
  return await newBackendAPI.post("menu-users", data);
};

export const UpdateUserPermission = async (data: UserPermission) => {
  return await newBackendAPI.patch("menu-users", data);
};

export const DashboardActivitiesByUser = async (
  startDate?: string,
  endDate?: string,
  status?: string,
  idClient?: number,
  name?: string,
  processNumber?: string,
  responsibles?: string,
) => {
  const params = {
    startDate,
    endDate,
    idClient: idClient === undefined ? idClient : `[${idClient}]`,
    name,
    processNumber,
    responsibles,
  };
  return await newBackendAPI.get(`/activities`, {params});
};

export const ActivityDataByUser = async (params: {
  activityId: number | string;
  userId: number | string;
  activityStatus: string;
  page: number;
  limit: number;
  startDate?: string;
  endDate?: string;
  idClient?: number;
  processNumber?: string;
  responsibles?: string;
}) => {
  return await newBackendAPI.get(`activities/${params?.activityId}`, {
    params: {
      ...params,
      idClient:
        params?.idClient === undefined
          ? params?.idClient
          : `[${params?.idClient}]`,
    },
    headers: {"x-user-id": params?.userId},
  });
};

export const AllActivitiesByUser = async (params: {
  startDate?: string;
  endDate?: string;
  taskIds?: string;
  idClient?: number;
  activityStatus: string;
  processNumber?: string;
  responsibles?: string;
  operationalResponsible?: string;
  classifications: string;
  page: number;
  limit: number;
  orderBy?: {column: string; order: "asc" | "desc"};
}) => {
  return await newBackendAPI.get(`activities-by-process`, {
    params: {
      ...params,
      idClient: !params?.idClient ? params?.idClient : `[${params?.idClient}]`,
    },
  });
};

export const GetUserPreferencesAndMenu = async () => {
  return await newBackendAPI.get(`/menu-itens`);
};

//o endpoint dessa requisição ainda vai mudar para /employees
export const GetEmployees = async (
  page: number,
  name?: string,
  limit?: number,
) => {
  const params = {
    filters: `["employee"]`,
    page,
    name,
    limit,
  };

  return await newBackendAPI.get(`/persons-by-type`, {params});
};

export const GetOnlyEmployees = async ({
  position,
  sector,
  name,
  page,
  limit,
}: {
  position?: string;
  sector?: string;
  name?: string;
  page?: number;
  limit?: number;
}) => {
  const params = {position, sector, name, page, limit};

  return await newBackendAPI.get(`/employees`, {params});
};
